import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import { Background, Container, Titulo, Hr, Button, Form, InputLabel, CheckBox } from "./style";
import Auth from "../../../services/auth";
import TitlePagination from "../../../components/TitlePagination";
import { IoIosArrowDown, IoMdCheckmark, IoMdCloseCircleOutline } from "react-icons/io";

export default function Fechamento() {
  const navigate = useNavigate();
  const [id] = useState(Auth.id());
  const [nomeCoord] = useState(Auth.nome());
  const [mes, setMes] = useState("");
  const [page, setPage] = useState(1);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [titlePage, setTitlePage] = useState("");
  const [idUsuario] = useState(Auth.id());
  const [fechamentosTemp, setFechamentosTemp] = useState([]);
  const [regras, setRegras] = useState([]);
  const [totalTitlePages, setTotalTitlePages] = useState(1);
  const [centrosCustos, setCentrosCustos] = useState([]);
  const [centrosCustosSelected, setCentroCustoSelected] = useState([]);
  const [idCentrosCustosSelected, setIdCentroCustoSelected] = useState([]);
  const [modalCentrosCustos, setModalCentrosCustos] = useState(false);
  const [reload, setReload] = useState(false);
  const modalRef = useRef(null);
  // Fecha o modal ao clicar fora dele
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setModalCentrosCustos(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setPage(1);
  }, [titlePage]);

  useEffect(() => {
    setTotalTitlePages(Math.ceil(fechamentosTemp?.length / 1) > 0 ? Math.ceil(fechamentosTemp?.length / 1) : 1);
  }, [fechamentosTemp]);

  const AlertaErro = (error) => {
    console.log(error);
    Swal.fire({
      title: "Atenção!",
      text: "Não foi possível consultar os dados!",
      icon: "error",
    });
  };

  useEffect(() => {
    // 1) Busca a regra de carga horária mínima
    api
      .get(`/regras?nome=CARGA HORARIA MINIMA MENSAL EFETIVO`)
      .then((response) => {
        // se veio array de regras
        if (response.data.regras) setRegras(response.data.regras[0]); // armazena a primeira
      })
      .catch((error) => AlertaErro(error)); // trata erro exibindo o alerta
    // 2) Carrega centros de custo do coordenador
    api
      .get(`/coord/costcenter?idCoord=${idUsuario}&fechamento=true`)
      .then((response) => {
        setCentrosCustos(response.data.centros_custo);
      })
      .catch((error) => AlertaErro(error)); // trata erro exibindo o alerta
  }, [idUsuario]); // executa só ao montar o componente

  useEffect(() => {
    let d = new Date();
    setMes(`${d.getFullYear()}-${d.getMonth() + 1 > 9 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`}`);
  }, []);

  useEffect(() => {
    if (mes) {
      setDataInicio(`${mes}-01`);
      setDataFim(`${mes}-${new Date(mes.split("-")[0], mes.split("-")[1], 0).getDate()}`);
    }
  }, [mes]);

  useEffect(() => {
    setTitlePage(1);
    if (idCentrosCustosSelected.length) {
      // Transforma [1,2,3] → "1|2|3"
      const centrosParam = idCentrosCustosSelected.length > 1 ? idCentrosCustosSelected.join("|") : idCentrosCustosSelected[0];
      api
        .get(`/coord/fechamentotemp?id_usuario=${idUsuario}&ids_centro_custo=${centrosParam}&data_inicio=${dataInicio}&data_fim=${dataFim}`)
        .then((response) => {
          setFechamentosTemp([]);
          setFechamentosTemp(response.data.fechamentos);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            title: "Atenção!",
            text: "Não foi possível consultar os dados!",
            icon: "error",
          });
        });
    } else {
      setFechamentosTemp([]);
    }
  }, [navigate, idUsuario, idCentrosCustosSelected, dataInicio, dataFim, reload]);

  function carga(data) {
    let counter = 0;
    data?.map((f, i) => {
      return (counter += f?.carga_horaria);
    });
    return parseFloat(counter);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (
      (dataInicio.split("-")[1] === mes.split("-")[1] || dataFim.split("-")[1] === mes.split("-")[1]) &&
      (dataInicio.split("-")[0] === mes.split("-")[0] || dataFim.split("-")[0] === mes.split("-")[0]) &&
      dataInicio <= dataFim &&
      mes !== ""
    ) {
      const data = {
        id_usuario: id,
        ano_mes: mes,
        data_inicio: dataInicio,
        data_fim: dataFim,
        ids_centro_custo: idCentrosCustosSelected,
      };

      try {
        const response = await api.post(`/coord/fechamentotemp`, {
          data,
        });
        if (response.data.error) return alert(response.data.error);
        Toast.fire({
          icon: "success",
          title: "Fechamento gerado com sucesso!",
        });
        setTimeout(() => {
          setReload(!reload);
        }, 1000);
      } catch (error) {
        alert(error);
      }
    } else {
      Swal.fire({
        title: "Atenção!",
        text: "As datas devem corresponder!",
        icon: "warning",
        confirmButtonColor: "var(--blue-color)",
      });
    }
  }

  return (
    <Background>
      <Container>
        <Titulo>
          <h1>Fechamento</h1>
          <legend>{nomeCoord}</legend>
        </Titulo>
        <Hr />
        <Form>
          <form onSubmit={handleSubmit}>
            <InputLabel style={{ gridArea: "c", position: "relative" }}>
              <label style={{ width: "150px" }}>Centro de Custo</label>
              <div onClick={() => setModalCentrosCustos((v) => !v)} style={{ cursor: "pointer" }}>
                {centrosCustosSelected.length > 0
                  ? centrosCustosSelected.length + " Centro de custo selecionados"
                  : "Selecione o centro de custo"}
                {modalCentrosCustos ? <IoMdCloseCircleOutline /> : <IoIosArrowDown />}
              </div>
              {modalCentrosCustos && (
                <div className="modalCentrosCustos" ref={modalRef}>
                  {centrosCustos
                    ?.filter((cc) => cc.nome !== "TODOS")
                    ?.map((c) => {
                      const selected = idCentrosCustosSelected.includes(c.id);
                      return (
                        <div
                          key={c.id}
                          className="modalOption"
                          onClick={() => {
                            // monta novo array de IDs
                            const novosIds = selected
                              ? idCentrosCustosSelected.filter((id) => id !== c.id)
                              : [...idCentrosCustosSelected, c.id];
                            // monta novo array de nomes
                            const novosNomes = selected
                              ? centrosCustosSelected.filter((nome) => nome !== c.nome)
                              : [...centrosCustosSelected, c.nome];
                            setIdCentroCustoSelected(novosIds);
                            setCentroCustoSelected(novosNomes);
                          }}
                        >
                          <CheckBox>
                            <IoMdCheckmark style={{ transition: "all 0.2s" }} color={selected ? "var(--blue-color)" : "transparent"} />
                          </CheckBox>
                          <span>{c.nome}</span>
                        </div>
                      );
                    })}
                </div>
              )}
            </InputLabel>
            <InputLabel style={{ gridArea: "m" }}>
              <label style={{ width: "50px" }}>Mês</label>
              <input
                type="month"
                value={mes}
                onChange={(e) => {
                  setMes(e?.target?.value);
                }}
              />
            </InputLabel>
            <InputLabel style={{ gridArea: "i" }}>
              <label style={{ width: "150px" }}>Início</label>
              <input
                type="date"
                value={dataInicio}
                disabled
                onChange={(e) => {
                  setDataInicio(e.target.value);
                }}
              />
            </InputLabel>
            <InputLabel style={{ gridArea: "f" }}>
              <label style={{ width: "50px" }}>Fim</label>
              <input
                type="date"
                value={dataFim}
                disabled
                onChange={(e) => {
                  setDataFim(e.target.value);
                }}
              />
            </InputLabel>
            <Button style={{ gridArea: "b" }}>Realizar Fechamento</Button>
            <Button
              onClick={() => {
                if (!centrosCustosSelected.length) {
                  return Swal.fire({
                    title: "Atenção!",
                    text: "Selecione um centro de custo!",
                    icon: "warning",
                    confirmButtonColor: "var(--blue-color)",
                  });
                }
                const rota = centrosCustosSelected.length > 1 ? "/fechamentopdfcoordtotal" : "/fechamentopdfcoord";
                navigate(rota, {
                  state: {
                    data_inicio: dataInicio,
                    data_fim: dataFim,
                    ...(centrosCustosSelected.length > 1
                      ? { centroCusto2: centrosCustosSelected }
                      : { centroCusto: centrosCustosSelected[0] }),
                    ...(idCentrosCustosSelected.length > 1
                      ? { idCentroCusto2: idCentrosCustosSelected }
                      : { idCentroCusto: idCentrosCustosSelected[0] }),
                  },
                });
              }}
              type="button"
              style={{
                gridArea: "p",
                cursor: "pointer",
                opacity: 1,
                pointerEvents: "auto",
              }}
            >
              Gerar Relatório
            </Button>
          </form>
        </Form>

        {fechamentosTemp?.slice((titlePage - 1) * 1, titlePage * 1)?.map((f, i) => (
          <React.Fragment key={i}>
            <TitlePagination page={titlePage} totalPages={totalTitlePages} setPage={setTitlePage} title={f?.colaborador} />
            <h4
              style={{
                textAlign: "center",
                marginBottom: "5px",
                marginTop: "20px",
              }}
            >
              Carga Horária no Período
            </h4>
            <table>
              <thead>
                <tr>
                  <th>Unidade</th>
                  <th>Curso</th>
                  <th>Evento</th>
                  <th>Carga Horária</th>
                </tr>
              </thead>
              <tbody>
                {f?.dados ? (
                  f?.dados.map((f2, i) => (
                    <tr key={i}>
                      <td
                        style={{
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          maxWidth: "200px",
                          paddingLeft: "5px",
                        }}
                        title={f2.unidade}
                        data-title="Unidade"
                      >
                        {f2.unidade}
                      </td>
                      <td data-title="Curso">{f2.curso}</td>
                      <td data-title="Evento">{f2.evento.toUpperCase()}</td>
                      <td data-title="Carga Horária">{f2.carga_horaria}</td>
                    </tr>
                  ))
                ) : (
                  <tr key={i}>
                    <td
                      style={{
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        maxWidth: "200px",
                        paddingLeft: "5px",
                      }}
                      title={f?.unidade}
                      data-title="Unidade"
                    >
                      {f?.unidade}
                    </td>
                    <td data-title="Curso">{f?.curso}</td>
                    <td data-title="Evento">{f?.evento.toUpperCase()}</td>
                    <td data-title="Carga Horária">{f?.carga_horaria}</td>
                  </tr>
                )}
                {f?.dados && page === Math.ceil(f?.dados?.length / 10) ? (
                  <tr>
                    <th
                      colSpan="3"
                      style={{
                        color: carga(f?.dados) < regras.valor && f?.vinculo === "ESTATUTARIO" ? "var(--red-color)" : "",
                      }}
                    >
                      Total:
                    </th>
                    <td
                      data-title="Total"
                      style={{
                        color: carga(f?.dados) < regras.valor && f?.vinculo === "ESTATUTARIO" ? "var(--red-color)" : "",
                      }}
                    >
                      {carga(f?.dados)}
                    </td>
                  </tr>
                ) : !f?.dados ? (
                  <tr>
                    <th
                      colSpan="3"
                      style={{
                        color: f?.carga_horaria < regras.valor && f?.vinculo === "ESTATUTARIO" ? "var(--red-color)" : "",
                      }}
                    >
                      Total:
                    </th>
                    <td
                      data-title="Total"
                      style={{
                        color: f?.carga_horaria < regras.valor && f?.vinculo === "ESTATUTARIO" ? "var(--red-color)" : "",
                      }}
                    >
                      {f?.carga_horaria}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
            {f?.deslocamentos?.length ? (
              <>
                <h4
                  style={{
                    textAlign: "center",
                    marginBottom: "5px",
                    marginTop: "20px",
                  }}
                >
                  Deslocamentos
                </h4>
                <table>
                  <thead>
                    <tr>
                      <th>Unidade</th>
                      <th>Curso</th>
                      <th>Evento</th>
                      <th>Origem</th>
                      <th>Destino</th>
                      <th>Qtde</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {f?.deslocamentos?.map((f2, i) => (
                      <tr key={i}>
                        <td
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: "100px",
                            paddingLeft: "5px",
                          }}
                          title={f2.unidade}
                          data-title="Unidade"
                        >
                          {f2.unidade}
                        </td>
                        <td data-title="Curso">{f2.curso}</td>
                        <td data-title="Evento">{f2.evento.toUpperCase()}</td>
                        <td data-title="Origem">{f2.cidade_origem}</td>
                        <td data-title="Destino">{f2.cidade_destino}</td>
                        <td data-title="Qtde">{f2.qtde}</td>
                        <td data-title="Carga Horária">
                          R${" "}
                          {f2.valor_deslocamento.toLocaleString("pt-br", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : null}
          </React.Fragment>
        ))}
      </Container>
    </Background>
  );
}
